export const projects = [{
    title: 'Bible App!',
    description: 'Displays the ESV bible publicly :) original, I know. Still, it\'s super quick to navigate and my notes are integrated with it!',
    img: 'lol',
    link: '/bible'
}]